import { QueryClient } from "react-query";
import { instance, is } from "superstruct";
import * as Sentry from "@sentry/react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3, // retry 3 times before failing
      onError: (error) => {
        if (is(error, instance(Error))) {
          Sentry.captureException(error);
        } else {
          Sentry.captureException("Unknown error");
          console.log("Couldn't send specific error to APM", error);
        }
      },
    },
  },
});
